import { BaseDto } from '../../base/dtos/base.dto';

/**
 * Language DTO
 */
export class LanguageDto extends BaseDto {
	/**
	 * Language UUID
	 */
	uuid!: string;

	/**
	 * Language name
	 */
	name!: string;

	/**
	 * ISO 639-1 language code
	 */
	isoCode!: string;

	/**
	 * Flag indicating whether this language is in use
	 */
	isVisible!: boolean;
}
